import createVueApp from '@phoenix/createVueApp';
import { defineAsyncComponent } from 'vue';
import CurrentCountry from '@phoenix/components/CurrentCountry';
import GeoLoc from '@maison/components/GeoLoc';
import WatchComparatorMenuEntry from '@maison/components/watchComparator/WatchComparatorMenuEntry.vue';
import WatchComparatorPill from '@maison/components/watchComparator/WatchComparatorPill.vue';
import { CURRENT_COUNTRY_CHANGED, emitter } from '@phoenix/event-bus';

const currentCountry = new CurrentCountry();
new GeoLoc(currentCountry);

const drawersLocalisations = document.querySelectorAll('.drawer-localisation');
drawersLocalisations.forEach((drawerLocalisation) => {
  drawerLocalisation.addEventListener('click', () => {
    emitter.on(CURRENT_COUNTRY_CHANGED, () => window.location.reload());
  });
});

Object.assign(window, {
  currentCountry,
  GeoLoc,
});

if (document.getElementById('phoenix-wishlist-panel')) {
  const app = createVueApp({}, true);
  app.component(
    'WishlistPanel',
    defineAsyncComponent(() => import('../components/wishlist/WishlistPanel.vue')),
  );
  app.mount('#phoenix-wishlist-panel');
}

if (document.getElementById('phoenix-cart-panel')) {
  const app = createVueApp({}, true);
  app.component(
    'CartPanel',
    defineAsyncComponent(() => import('../components/checkout/summary/CartPanel.vue')),
  );
  app.mount('#phoenix-cart-panel');
}

if (document.getElementById('phoenix-card-badge')) {
  const app = createVueApp({}, true);
  app.component(
    'Badge',
    defineAsyncComponent(() => import('../components/checkout/summary/Badge.vue')),
  );
  app.mount('#phoenix-card-badge');
}

if (document.getElementById('phoenix-account-panel')) {
  const app = createVueApp({}, true);
  app.component(
    'AccountPanel',
    defineAsyncComponent(() => import('../components/myAccount/nav/AccountPanel.vue')),
  );
  app.mount('#phoenix-account-panel');
}

if (document.getElementById('phoenix-search-form-container')) {
  const app = createVueApp({}, true);
  app.component(
    'SearchForm',
    defineAsyncComponent(() => import('../components/search/SearchForm.vue')),
  );
  app.mount('#phoenix-search-form-container');
}

Array.from(document.querySelectorAll('.phoenix-watch-comparator-pill')).forEach((el) => {
  const app = createVueApp({}, false);
  app.component('WatchComparatorPill', WatchComparatorPill);
  app.mount(el);
});

if (document.getElementById('phoenix-watch-comparator-menu-mobile')) {
  const app = createVueApp({}, false);
  app.component('WatchComparatorMenuEntry', WatchComparatorMenuEntry);
  app.mount('#phoenix-watch-comparator-menu-mobile');
}
